import { Icon } from './Icons';

export function AckList({ items, checked, onToggle }) {
  return (
    <div className="ack-list">
      {items.map((a) => (
        <label className="ack-item" key={a.key}>
          <input
            type="checkbox"
            checked={!!checked[a.key]}
            onChange={(e) => onToggle(a.key, e.target.checked)}
          />
          <span className="ack-box"><Icon.Check width="12" height="12" /></span>
          <span className="ack-text">
            {a.label}
            {a.required && <span className="ack-req"> · required</span>}
          </span>
        </label>
      ))}
    </div>
  );
}
